import React from "react";
import { Route, Routes } from "react-router-dom";

import ErrorBoundary from "@/pages/ErrorBoundary";
import NotFound from "@/pages/NotFound";
import Main from "@/pages/Main";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";

function Router() {
  return (
    <Routes>
      <Route path="/" element={<Main />} errorElement={<ErrorBoundary />}>
        <Route index element={<Dashboard />} />
        <Route path="chat" element={<Chat />} />
        <Route path="chat/:channelId" element={<Chat />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Router;
